import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';
import Image from '../common/Image';

const useStyles = makeStyles()(() => ({
  image: {
    width: '229px',
    height: '65px',
  },
  image1: {
    width: '209px',
    height: '33px',
    maxHeight: '33px',
  },
  image3: {
    width: '106px',
    height: '84px',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 138,
    padding: '16px !important',
  },
}));

const AnnArborSponsorsBlock = () => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');

  return (
    <Grid container spacing={6} sx={{ pb: '180px' }}>
      {/* Left column */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5" fontWeight={700} sx={{ pb: 4 }}>
          {t('sponsorsBlock.presentedBy')}
        </Typography>
        <Grid container spacing={2}>
          {/* Card 1 */}
          <Grid item xs={6} sm={6}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 4,
                bgcolor: '#F5F6FA',
              }}
            >
              <CardContent className={classes.card}>
                <Image
                  variant="aspectRatio"
                  objectFit="contain"
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  className={classes.image}
                  src="/static/svg/homepage/supporters/BrandRefresh_OfGreaterAnnArbor.svg"
                  alt="/static/svg/homepage/supporters/BrandRefresh_OfGreaterAnnArbor.svg"
                />
              </CardContent>
            </Card>
          </Grid>
          {/* Card 2 */}
          <Grid item xs={6} sm={6}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 4,
                bgcolor: '#F5F6FA',
              }}
            >
              <CardContent className={classes.card}>
                <Image
                  variant="aspectRatio"
                  objectFit="contain"
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  className={classes.image1}
                  src="/static/svg/homepage/supporters/JCC_logo.svg"
                  alt="/static/svg/homepage/supporters/JCC_logo.svg"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      {/* Right column */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5" fontWeight={700} sx={{ pb: 4 }}>
          {t('sponsorsBlock.supportedBy')}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 4,
                bgcolor: '#F5F6FA',
              }}
            >
              <CardContent className={classes.card}>
                <Image
                  variant="wide"
                  objectFit="contain"
                  className={classes.image3}
                  src="/static/svg/homepage/supporters/JCFlogo.svg"
                  alt="/static/svg/homepage/supporters/JCFlogo.svg"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AnnArborSponsorsBlock;
